// This file is automatically generated. Do not edit manually.

import { CostEventObjectRef } from "src/api/generated/erp/common/costEvents/model/costEventObjectRef";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { CostEvent } from "src/api/generated/erp/db/types/tables/costEvent";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { CostEventView } from "src/api/generated/erp/db/types/tables/costEventView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CostEventsDataGridApi {
	export async function getDataGridData(args: {
		objectRef?: CostEventObjectRef | null | undefined;
		onlyOwnEvents?: boolean;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<CostEventsDataGridApi_GridData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/costEvents/costEventsDataGrid/getDataGridData",
			method: "POST",
			data: {
				objectRef: args.objectRef,
				onlyOwnEvents: args.onlyOwnEvents,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as CostEventsDataGridApi_GridData;
	}

	export async function delete_(args: { costEvents: Array<CostEvent> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/costEvents/costEventsDataGrid/delete",
			method: "POST",
			data: {
				costEvents: args.costEvents,
			},
		});
		return response as void;
	}
}

export interface CostEventsDataGridApi_GridData {
	costEventsData: ServerSideDataModelResult<CostEventView>;
	totalCosts: number;
	totalPrice: number;
}
